import { render, staticRenderFns } from "./LogoFrameIcon.vue?vue&type=template&id=32deba6f&"
import script from "./LogoFrameIcon.vue?vue&type=script&lang=js&"
export * from "./LogoFrameIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports